/**
 * Custom checkout B2C — faktura: dane firmy z NIP (MF Biała Lista) i osobny adres firmy.
 *
 * „Pobierz dane z NIP” wypełnia nazwę firmy i adres firmy; gdy adres różni się od adresu
 * z kroku „Adres”, zaznacza „Adres firmy na fakturze jest inny”. Serwer (inc/checkout.php)
 * przekłada wtedy adres z kroku 2 do dostawy, a adres firmy do billing (faktura w BaseLinkerze).
 */

const norm = (v) => (v || '').toLowerCase().replace(/^(ul\.|al\.|pl\.)\s*/, '').replace(/[^a-z0-9ąćęłńóśźż]/g, '');

export function initCheckoutInvoice() {
    const form = document.querySelector('form.checkout.hn-co');
    const section = form && form.querySelector('.hn-co__inline-toggle--invoice');
    if (!section) return;

    const want = section.querySelector('[data-hn-co-inline-trigger]');
    const other = section.querySelector('[data-hn-co-invoice-other]');
    const box = section.querySelector('[data-hn-co-invoice-address]');
    const fields = box ? [...box.querySelectorAll('input')] : [];
    const btn = section.querySelector('[data-hn-co-nip-fetch]');
    const nipInput = section.querySelector('#billing_nip');
    const status = section.querySelector('[data-hn-co-nip-status]');
    const val = (id) => (document.getElementById(id) || {}).value || '';

    const sync = () => {
        const on = !!(want && want.checked && other && other.checked);
        if (box) box.hidden = !on;
        fields.forEach((inp) => {
            inp.disabled = !on;
            inp.required = on;
        });
    };

    const setVal = (id, v) => {
        const el = document.getElementById(id);
        if (!el || v == null || v === '') return;
        el.value = v;
        el.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const setStatus = (msg, kind) => {
        if (!status) return;
        status.textContent = msg;
        status.hidden = !msg;
        status.className = 'hn-co__nip-status' + (kind ? ' is-' + kind : '');
    };

    section.addEventListener('hn-co-inline-toggle', sync);
    if (other) other.addEventListener('change', sync);
    sync();

    const cfg = window.HN_CHECKOUT || {};
    if (!btn || !nipInput || !cfg.nipLookup) return;

    btn.addEventListener('click', () => {
        const nip = (nipInput.value || '').replace(/[^0-9]/g, '');
        if (nip.length !== 10) {
            setStatus('Podaj 10-cyfrowy NIP', 'err');
            nipInput.focus();
            return;
        }
        btn.disabled = true;
        btn.classList.add('is-loading');
        setStatus('Szukam w rejestrze MF…', 'loading');

        fetch(`${cfg.nipLookup}?nip=${encodeURIComponent(nip)}`, { headers: { 'X-WP-Nonce': cfg.nonce || '' } })
            .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
            .then(({ ok, d }) => {
                if (!ok) {
                    setStatus((d && d.message) || 'Nie znaleziono firmy dla tego NIP', 'err');
                    return;
                }
                setVal('billing_company', d.name);
                if (d.street || d.postcode || d.city) {
                    setVal('hn_invoice_address_1', d.street);
                    setVal('hn_invoice_postcode', d.postcode);
                    setVal('hn_invoice_city', d.city);
                    const same = norm(d.street) === norm(val('billing_address_1'))
                        && norm(d.postcode) === norm(val('billing_postcode'));
                    if (other) {
                        other.checked = !same;
                        sync();
                    }
                }
                if (d.name_complete === false) {
                    // Biała Lista dla JDG zwraca tylko imię i nazwisko, bez nazwy firmy.
                    setStatus('W rejestrze VAT jest tylko imię i nazwisko. Dopisz nazwę firmy, jeśli ma być na fakturze.', 'warn');
                    const company = document.getElementById('billing_company');
                    if (company) {
                        company.focus();
                        company.setSelectionRange(company.value.length, company.value.length);
                    }
                    return;
                }
                setStatus(`Pobrano: ${d.name || 'dane firmy'}. Możesz je poprawić.`, 'ok');
            })
            .catch(() => setStatus('Błąd połączenia z rejestrem. Wpisz dane ręcznie.', 'err'))
            .finally(() => {
                btn.disabled = false;
                btn.classList.remove('is-loading');
            });
    });
}
